fx.ns("desktop.calendar", class PhotoChoices extends desktop.common.photoimport.PhotoChoices {
    
	constructor()
	{
		super({file: false, albums: false});
	}

	onReady()
	{
		super.onReady();

        this.on("photo-extracted", this._onPhotoExtracted, fx.service("MediasUploader") );
        this.on("photo-extracted-started", this._onPhotoExtractedStarted, fx.service("MediasUploader") );
        this.on("photo-extracted-finished", this._onPhotoExtractedFinished, fx.service("MediasUploader") );

        // no -finished on GoogleService : the validation moves on now, not the end of the fetch
        this.on("photo-extracted", this._onPhotoExtracted, fx.service("GoogleService"));
	}

    _onPhotoExtractedStarted()
	{
		this.popup(new shared.popups.ExtractingPhotosPopup());
	}
    
    _onPhotoExtracted(e)
    {
    }

    _onPhotoExtractedFinished(e)
    {
        if (fx.get("mode") == "creating")
            this.data.event("next-step");
        else
            this.data.event("show-editor");
        
    }

	close()
	{
        if (fx.get("mode") == "creating")
            this.data.event("next-step");
		else
            this.data.event("show-editor");
	}

});